import {isEmpty} from 'lodash';
import {ActivatedRoute} from '@angular/router';
import {HeaderComponent} from '../header/header.component';
import {Component, OnInit, ViewChild} from '@angular/core';
import {Keys, StorageService} from '../service/storage.service';
import {LoanApplicationFlowNavigator} from '../application-flow/loan-application-flow.navigator';
import {Location} from '@angular/common';

@Component({
    styleUrls: ['./loan-application-flow.css'],
    templateUrl: './loan-application-flow.html'
})
export class LoanApplicationFlowComponent implements OnInit {
    public isPartnerWebsite: boolean;
    public partnerLogoUrl: string;
    private readonly route: ActivatedRoute;
    private readonly storageService: StorageService;
    private readonly flowNavigator: LoanApplicationFlowNavigator;
    private readonly location: Location;

    @ViewChild(HeaderComponent, {static: true})
    private headerComponent: HeaderComponent;

    constructor(location: Location, loanApplicationFlowNavigator: LoanApplicationFlowNavigator,
                storageService: StorageService, route: ActivatedRoute) {
        this.route = route;
        this.storageService = storageService;
        this.flowNavigator = loanApplicationFlowNavigator;
        this.location = location;
    }

    onLoad() {
        this.headerComponent.onUserLoggedIn();
    }

    isFirstPage(): boolean {
        return this.location.path().endsWith('intro');
    }

    ngOnInit(): void {
        const domain = this.storageService.getItem(Keys.DOMAIN);
        this.isPartnerWebsite = !(isEmpty(domain) || domain === 'finzy');

        this.route.data.subscribe(data => {
            this.partnerLogoUrl = data.partnerLogoUrl;
        });
    }
}